import React, {useEffect, useRef, useState} from 'react';
import {FaPlusCircle} from "react-icons/fa";
import {LuImport} from "react-icons/lu";
import Header from "../../components/navigation/Header";
import {deleteQuiz, getAllTags, getAllTests, saveQuiz, uploadQuizFile} from "../../services/TestRepository";
import {FiSave} from "react-icons/fi";
import {Dropdown} from "react-bootstrap";
import {getAssembledTest} from "../../services/API";
import {TagDropdown} from "../../components/quiz/TagDropdown";
import {getInterpolatedColor, space_palette} from "../../components/color/Palettes";
import {useError} from "../../hooks/useError";


export function QuizCreation() {


    const [quizList, setQuizList] = useState([]);
    const [dropdownText, setDropdownText] = useState("Velg eksisterende quiz")
    const [quiz, setQuiz] = useState({
        name: "New quiz",
        description: "",
        questions:[]
    });
    const [name, setName] = useState("New quiz");
    const [description, setDescription] = useState("");
    const [file, setFile] = useState(null);
    const [tags, setTags] = useState([]);
    const [excludedToggle, setExludedToggle] = useState([]);
    const fileBtnRef = useRef();
    const {setErrorMessage} = useError()

    useEffect(() => {
        getAllTests().then(result => {
            setQuizList(result)
        }).catch(err => console.log(err.message))

        getAllTags().then(result => setTags(result)).catch(err => console.log(err.message))
    }, []);

    function toggleQuestion(index) {
        if(excludedToggle.includes(index)) {
            let copy = [...excludedToggle];
            copy.splice(copy.indexOf(index), 1)
            setExludedToggle(copy)
        } else {
            setExludedToggle([...excludedToggle, index])
        }
    }

    function updateQuiz(key, value) {
        const copy = {...quiz};
        copy[key] = value;
        setQuiz(copy);
    }


    function updateQuestion(idx, value) {
        const copy = {...quiz};
        let question = copy.questions[idx];
        question.text = value;
        copy[idx] = question;
        setQuiz(copy);
    }

    function addTag(idx, tag) {
        const copy = {...quiz};
        let question = copy.questions[idx];

        if(!question.tags.includes(tag)) {
            question.tags.push(tag);
        }

        copy[idx] = question;
        setQuiz(copy);
    }
    function updateOption(questionIdx, idx, value) {
        const copy = {...quiz};
        let question = copy.questions[questionIdx];
        question.options[idx].text = value;
        copy[questionIdx] = question;
        setQuiz(copy);
    }

    function save() {
        saveQuiz(quiz).then(result => {console.log("SAVE: "+result)}).catch(err => console.log(err.message))
    }

    function importFromFile(file) {
        uploadQuizFile(file).then(result => {
            console.log(result)
            const copy = {...quiz};
            copy.questions = result.questions;
            setQuiz(copy)
        }).catch(err => console.log(err.message));
    }

    if(quizList != null) {
        return (
            <>
                <Header></Header>
                <div className={"container py-5"}>
                    <h2>Create or edit quiz</h2>
                    <div className={"row"}>
                        <Dropdown className={"col mb-3"}>
                            <Dropdown.Toggle variant="dark" id="dropdown-basic" className={"w-100 text-white py-2"}>
                                {dropdownText}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className={"w-100"}>
                                {
                                    quizList.map(item => (
                                        <Dropdown.Item onClick={() => getAssembledTest(item.id).then(result => {
                                            setQuiz(result)
                                            console.log(result)
                                        }).catch(err => console.log(err.message))}>{item.name}</Dropdown.Item>
                                    ))
                                }
                            </Dropdown.Menu>
                        </Dropdown>

                        <button className={"col-3 btn btn-success text-white mb-3"}
                                onClick={() => fileBtnRef.current.click()}>
                            <input type={"file"} accept={"text/csv"} ref={fileBtnRef} className={"d-none"}
                                   onChange={e => importFromFile(e.target.files[0])}/>
                            <LuImport size={24} className={"me-2"}/>
                            <label>Importer fra CSV</label>
                        </button>
                        <div className={"col-2"}>
                            <button className={"btn btn-danger text-white mb-3"} onClick={() => deleteQuiz(quiz.testId, setErrorMessage)}>Delete quiz</button>
                        </div>
                    </div>

                    <input className={"form-control mb-2"} value={quiz.name}
                           onChange={e => updateQuiz("name", e.target.value)} placeholder={"Navn"}/>
                    <textarea className={"form-control mb-2"} placeholder={"Beskrivelse"} value={quiz.description}
                              onChange={e => updateQuiz("description", e.target.value)}/>

                    {
                        quiz.questions.map((item, qIdx) => (
                            <div className={"rounded border my-2 p-3"}>
                                <div className={"row mb-2 pe-3"}>
                                    <div className={"col"}>
                                        <h5 className={""}>Question {qIdx + 1}</h5>
                                        <label className={"text-muted"}>
                                            ID: {item.id}
                                        </label>
                                    </div>
                                    <button className={"col-1 btn btn-light border"}
                                            onClick={() => toggleQuestion(qIdx)}>Toggle
                                    </button>
                                </div>
                                <input className={"form-control fw-bold"} value={item.text}
                                       onChange={(e) => updateQuestion(qIdx, e.target.value)}/>

                                <div className={(excludedToggle.includes(qIdx) ? "d-none" : "")}>
                                    {
                                        item.options.map((option, idx) => (

                                            <div className={"pt-2 px-3 d-flex align-items-center"}>
                                                <label className={"me-2"}>{["A", "B", "C", "D"][idx]}.</label>
                                                <input className={"form-control mb-2"} type={"text"} value={option.text}
                                                       onChange={(e) => updateOption(qIdx, idx, e.target.value)}/>
                                            </div>

                                        ))
                                    }
                                </div>
                                <div className={"rounded border p-3 m-2"}>
                                    <div className={"row"}>
                                        <p className={"col"}>Tags</p>
                                        <TagDropdown className={"col-2 mt-3"} tags={tags}
                                                     selectCallback={(x) => addTag(qIdx, x)}/>
                                    </div>
                                    {
                                        item.tags.map((tag, idx) => (
                                            <span className={"badge p-2 me-2"} style={{
                                                fontSize: "0.8rem",
                                                backgroundColor: getInterpolatedColor(space_palette, idx, 0, item.tags.length)
                                            }}>
                                            {tag.text}
                                        </span>
                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }


                    <button className={"btn btn-primary text-white me-2"}>
                        <FaPlusCircle size={24} className={"me-2"}/>
                        <label>Oppgave</label>
                    </button>


                    <button className={"btn btn-success"} onClick={() => save()}>
                        <FiSave size={24} className={"me-2"}/>
                        <label>Lagre</label>
                    </button>
                </div>
            </>

        );
    }

}